export const DEFAULT_WEIGHTS_LABEL = 'Default Weights';
export const DEFAULT_WEIGHTS_EXTENSIONS = ['.pt', '.keras'];

export function defaultWeightsLabel(field) {
  const label = typeof field?.default_label === 'string' ? field.default_label.trim() : '';
  return label || DEFAULT_WEIGHTS_LABEL;
}

export function weightsExtensions(field) {
  const filter = field?.artifacts_filter;
  if (!Array.isArray(filter) || filter.length === 0) {
    return [...DEFAULT_WEIGHTS_EXTENSIONS];
  }
  return filter.map((ext) => String(ext).toLowerCase());
}

export function sessionRef(id) {
  let n;

  if (typeof id === 'number') {
    n = id;
  } else if (typeof id === 'string' && /^[0-9]+$/.test(id)) {
    n = Number(id);
  } else {
    return '';
  }

  if (!Number.isSafeInteger(n) || n <= 0) {
    return '';
  }

  return `t-${n.toString(16)}`;
}

export function sessionLabel(session) {
  const ref = sessionRef(session?.id);
  const name = String(session?.name || '').trim();
  if (!ref) {
    return name;
  }
  return name ? `${ref} · ${name}` : ref;
}

export function filterSessionsByModel(sessions, modelType) {
  if (!modelType) {
    return sessions;
  }
  const wanted = String(modelType).toLowerCase();
  return (sessions || []).filter((session) => String(session?.model || '').toLowerCase() === wanted);
}

export function weightsValue(useDefault, sessionId, artifact) {
  if (useDefault) {
    return {};
  }
  return { weights_session: sessionRef(sessionId), weights_artifact: artifact || '' };
}

export function isWeightsValueComplete(value) {
  if (!value || Object.keys(value).length === 0) {
    return true;
  }
  return !!value.weights_session && !!value.weights_artifact;
}

export function schemaHasWeightsField(fields) {
  if (!Array.isArray(fields)) {
    return false;
  }
  return fields.some((field) => {
    if (!field || typeof field !== 'object') {
      return false;
    }
    if (field.type === 'weights') {
      return true;
    }
    if (schemaHasWeightsField(field.children)) {
      return true;
    }
    return Array.isArray(field.options) && field.options.some((option) => schemaHasWeightsField(option?.children));
  });
}
